import {
  Button,
  Classes,
  Collapse,
  Dialog,
  HTMLTable,
  Icon,
  Radio,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import {
  INotaItem,
  IResultadoItem,
} from "../../../../model";
import { ResultadoStore } from "../../../../stores/resultados/ResultadoStore";
import { AppStore } from "../../../../stores/AppStore";
import { copyToClipboard } from "../../../../utils";
import { toast } from "react-toastify";
import { api } from "../../../../api";
import { ContestarSugerido } from "../../../contestar/ContestarSugerido";
import InfiniteScroll from "react-infinite-scroll-component";
import { AppIcon } from "../../../utils/AppIcon";

import 'katex/dist/katex.min.css';
import { ItemMemoria } from "./ItemMemoria";
import { MDBBtn } from "mdbreact";
import moment from "moment";

const numeral = require("numeral");

interface Props {
  item: IResultadoItem;
  modelo: string;
  entrada_saida: string;
  data: any;
  onClose: () => void;
}

interface State {
  isOpen?: boolean;
  isOpenSugeridos?: boolean;
  produtos: any[];
}

@observer
export class NotaItemDialog extends React.Component<Props, State> {

  obs = observable({
    item: {} as INotaItem,
    dhemi: "" as string,
    contestarItem: null as IResultadoItem,
    openContestar: false as boolean,
    current_page: 1 as number,
    loading: false as boolean
  })

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isOpenSugeridos: false,
      produtos: []
    };

  }

  async componentDidMount() {

    let data = {
      chave: this.props.item.chave_nota,
      tipo: this.props.entrada_saida.toLowerCase(),
      item: this.props.item.id,
      modelo: this.props.modelo,
    };

    try {
      let resp = await api.post(`/api/notas/item`, data);
      this.obs.dhemi = resp.data.dhemi;
      this.obs.item = resp.data;

      if(resp.data.calc.id) await ResultadoStore.loadDetalhamentoCalculo(resp.data.calc.id)

    } catch (ex) { }
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleViewXML = async (chave: string, entrada_saida: string, modelo: string, dhemi: string) => {

    await ResultadoStore.download_xml(chave, entrada_saida, modelo, dhemi, AppStore.obs1.selectedEmpresa.cnpj);

  };

  handleCopyChave = () => {
    copyToClipboard(this.obs.item.nota?.chave);
    toast.success("Chave de acesso copiada", {});
  };

  handleCopyId = () => {
    copyToClipboard(this.obs.item?.contestacao_id);
    toast.success("Id Contestação copiado", {});
  };

  handleContest(calc_id: string) {

    let item = { ...this.props.item }

    item.calc_id = calc_id

    this.obs.contestarItem = item
    this.obs.openContestar = true

  }

  handleViewPDF = async () => {

    var ids = {
      ids: [this.obs.item.nota_id],
      filtro: this.props.entrada_saida,
      tipo: this.props.modelo,
      empresa: AppStore.obs1.selectedEmpresa.cnpj,
      data1: moment(this.obs.item.dhemi).format("YYYY-MM-DD"),
      data2: moment(this.obs.item.dhemi).format("YYYY-MM-DD"),
    };

    await ResultadoStore.view_danfe(ids, this.obs.item.nota?.chave);

  };

  renderDetailsTab() {
    const icmsAPagar = this.obs.item.valor_icms_ant - (this.obs.item.valor_contestacao_icms || 0);

    return (
      <div>
        {this.props.item?.calculo_memoria_salva && (
          <div className="item-dialog-memoria-badge">
            <span>Item contestado automaticamente via memória de cálculo salva.</span>
          </div>
        )}

        <div className="item-dialog-chave">
          <span className="detalhamento-field-label">Chave de acesso</span>
          <div className="item-dialog-chave-value">
            <span>{this.obs.item.nota?.chave}</span>
            <Button small minimal icon="clipboard" onClick={this.handleCopyChave} />
          </div>
        </div>

        <div className="item-dialog-descricao">
          <span className="detalhamento-field-label">Descrição</span>
          <span style={{lineHeight: 1.5, textAlign: "justify"}}>{this.obs.item.descricao}</span>
        </div>

        <div className="item-dialog-grid">
          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Série / Número</span>
            <span className="detalhamento-field-value">
              {this.obs.item.nota?.serie}/{this.obs.item.nota?.numero} (item {this.obs.item.numero})
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Valor NFe</span>
            <span className="detalhamento-field-value">{numeral(this.obs.item.nota?.valor).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Valor do Item</span>
            <span className="detalhamento-field-value">{numeral(this.obs.item.valor).format("$ 0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">FCP Calculado</span>
            <span className="detalhamento-field-value" style={{ fontWeight: 700 }}>
              {numeral(this.obs.item.valor_fcp).format("$ 0,0.00")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">ICMS Calculado</span>
            <span className="detalhamento-field-value" style={{ fontWeight: 700 }}>
              {numeral(this.obs.item.valor_icms_ant).format("$ 0,0.00")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Contestado</span>
            <span className="detalhamento-field-value">
              {numeral(this.obs.item.valor_contestacao_icms || 0).format("$ 0,0.00")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Data da inserção</span>
            <span className="detalhamento-field-value">
              {moment(this.obs.item.inserted_at).format("L LT")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Data da atualização</span>
            <span className="detalhamento-field-value">
              {moment(this.obs.item._modifiedTS).format("L LT")}
            </span>
          </div>

        </div>

        <div className="item-dialog-apagar">
          <span className="detalhamento-field-label">ICMS a Pagar</span>
          <span className="detalhamento-field-value valor-pagar" style={{ fontSize: 18 }}>
            {numeral(icmsAPagar).format("$ 0,0.00")}
          </span>
        </div>

        {this.obs.item?.contestacao_id && (
          <div className="item-dialog-chave" style={{ marginTop: 12 }}>
            <span className="detalhamento-field-label">ID Contestação</span>
            <div className="item-dialog-chave-value">
              <span>{this.obs.item?.contestacao_id}</span>
              <Button small minimal icon="clipboard" onClick={this.handleCopyId} />
            </div>
          </div>
        )}

        <div className="item-dialog-actions">
          <MDBBtn
            className="btnDefault btnExportResultados"
            icon="document"
            onClick={() => this.handleViewXML(this.obs.item.nota?.chave, this.props.entrada_saida, this.props.modelo, this.obs.dhemi)}
          >Download XML</MDBBtn>
          <MDBBtn
            className="btnDefault btnExportResultados"
            icon="document-open"
            onClick={() => this.handleViewPDF()}
          >Download PDF</MDBBtn>
        </div>
      </div>
    );
  }

  renderMemoriaCalc(memoria_calculo: string) {

    let calcName: any = this.obs.item.calc ? this.obs.item.calc.nome : "Nenhum";

    return (
      <ItemMemoria
        memoria_calculo={memoria_calculo}
        calcName={calcName}
        calc_vars={ResultadoStore.obs.calc_vars}
        nota_vars={ResultadoStore.obs.nota_vars}
        descritivo={ResultadoStore.obs.descritivo_calc}
      />
    );
  }

  renderMemoriaCalcFcp(memoria_calculo: string) {

    let calcName: any = this.obs.item.calc ? this.obs.item.calc.nome : "Nenhum";

    return (
      <ItemMemoria
        memoria_calculo={memoria_calculo}
        calcName={calcName}
        calc_vars={ResultadoStore.obs.calc_vars_fcp}
        nota_vars={ResultadoStore.obs.nota_vars_fcp}
        descritivo={ResultadoStore.obs.descritivo_calc}
      />
    );
  }

  renderAlert() {
    let aux = [];

    if (this.obs.item.ie) {
      aux = this.obs.item.ie.split("\n")?.map((x) => {
        return (
          <>
            <p>
              <b>Alerta:</b> {x}
            </p>
          </>
        );
      });
    }
    if (this.obs.item.monofasico) {
      aux.push(
        <>
          <p>
            <b>Alerta:</b> {this.obs.item.monofasico_msg}
          </p>
        </>
      );
    }
    if (this.obs.item.calc_sugerido) {
      aux.push(
        <>
          <p>
            <b>Cálculo sugerido:</b> {this.obs.item.calc_sugerido_msg}
          </p>
        </>
      );
    }

    return (
      <>
        <div style={{ marginBottom: 10 }}>{aux}</div>
      </>
    );

  }

  renderData() {

    let items = this.state.produtos?.map(produto => {
      return (
        <tr key={produto.id}>
          <td>{produto.cest}</td>
          <td>{produto.ncm}</td>
          <td>{produto.descricao}</td>
        </tr>
      );
    });

    let calcs = this.obs.item.sugerido_list?.map(calc => {

      let isChecked = (this.obs.contestarItem && this.obs.contestarItem.calc_id) ? true : false

      return (
        <tr key={calc.calc_id} onClick={() => this.handleContest(calc.calc_id)}>
          <td style={{ padding: "10px 0px 0px 5px" }}><Radio checked={isChecked} /></td>
          <td style={{ padding: "10px 0px 0px 5px" }}>{calc.calc_name}</td>
        </tr>
      );
    });

    return (
      <Tabs id="tabs" className="tabsCalculos tabsDetail">
        <Tab id="details" title="Detalhes" panel={this.renderDetailsTab()} />
        {this.obs.item.memoria_calculo ?
          <Tab
            id="calc"
            title="Memória de cálculo ICMS"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo)}
          />
          : <></>}
        {this.obs.item.memoria_calculo_1139 ?
          <Tab
            id="calc_1139"
            title="Memória de cálculo ICMS 1139"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo_1139)}
          />
          : <></>}
        {this.obs.item.memoria_calculo_fcp && ResultadoStore.obs.empresaContestar.uf == "RS" ?
          <Tab
            id="calc_fcp"
            title="Memória de cálculo FCP"
            panel={this.renderMemoriaCalcFcp(this.obs.item.memoria_calculo_fcp)}
          />
          : <></>}
        {(this.obs.item.ie || this.obs.item.monofasico) &&
          (
            <Tab
              id="alert"
              title="Alerta de Cálculo"
              panel={<>

                {this.renderAlert()}

                <div>

                  <span style={{ color: "#3e6971", textDecoration: "underline", cursor: "pointer" }}><b onClick={this.handleClick}>Visualizar Produto {this.state.isOpen ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}</b></span>

                  <Collapse isOpen={this.state.isOpen}>
                    <div
                      className="scroll-produtos"
                      id="scrollableDiv"
                      style={{
                        maxHeight: 250,
                        overflow: 'auto',
                        display: 'flex'
                      }}
                    >
                      <InfiniteScroll
                        dataLength={this.state.produtos.length}
                        next={this.fetchMoreAvisos}
                        hasMore={true}
                        style={{ display: 'flex' }}
                        scrollableTarget="scrollableDiv"

                        loader={this.obs.loading ?
                          <div style={{ textAlign: "center" }}>
                            <div className="spinner-border" role="status">
                              <span className="sr-only"></span>
                            </div>
                          </div>
                          : ""}
                      >
                        <HTMLTable className="table table-hover dataTable" style={{ width: "100%" }}>
                          <thead>
                            <tr>
                              <th style={{ width: 120, color: "#3e6971" }}>CEST</th>
                              <th style={{ width: 120, color: "#3e6971" }}>NCM</th>
                              <th style={{ color: "#3e6971" }}>Descrição</th>
                            </tr>
                          </thead>
                          <tbody>
                            {items}
                          </tbody>
                        </HTMLTable>
                      </InfiniteScroll>
                    </div>
                  </Collapse>
                </div>

                {this.obs.item.sugerido_list && this.obs.item.sugerido_list.length ?
                  <div>
                    <span style={{ color: "#3e6971", textDecoration: "underline", cursor: "pointer" }}><b onClick={this.handleClickSugeridos}>Visualizar Cálculos Sugeridos{this.state.isOpenSugeridos ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}</b></span>

                    <Collapse isOpen={this.state.isOpenSugeridos}>
                      <div style={{ maxHeight: 250, overflow: "auto" }}>
                        <HTMLTable className="table table-hover dataTable" style={{ width: "100%" }}>
                          <thead>
                            <tr>
                              <th style={{ width: 20 }} />
                              <th>Nome</th>
                            </tr>
                          </thead>
                          <tbody>
                            {calcs}
                          </tbody>
                        </HTMLTable>
                      </div>

                      <b>Escolha um cálculo acima para contestar o item selecionado.</b>

                    </Collapse>
                  </div>
                  : <></>}

              </>}>
              <span className="badge-emp pulse badge-tab"></span>
            </Tab>

          )}

      </Tabs>
    );
  }

  handleClick = () => {

    this.setState({ isOpen: !this.state.isOpen }, async () => {

      this.obs.loading = true

      this.obs.current_page = 1

      this.setState({ produtos: await ResultadoStore.loadProdutos(this.obs.current_page, this.props.item.ncm, this.props.item.cest, ResultadoStore.obs.tipo, AppStore.obs1.selectedEmpresa.uf) })

      this.obs.loading = false

    });

  }

  fetchMoreAvisos = async () => {

    this.obs.loading = true

    this.obs.current_page = this.obs.current_page + 1

    let resp = await ResultadoStore.loadProdutos(this.obs.current_page, this.props.item.ncm, this.props.item.cest, ResultadoStore.obs.tipo, AppStore.obs1.selectedEmpresa.uf)

    this.setState({ produtos: [...this.state.produtos, ...resp] })

    this.obs.loading = false

  };

  handleClickSugeridos = () => {

    this.setState({ isOpenSugeridos: !this.state.isOpenSugeridos })

  }

  handleCloseContestar() {

    this.obs.openContestar = false
    this.obs.contestarItem = null

    this.props.onClose()

  }

  handleCancelContestar() {

    this.obs.openContestar = false
    this.obs.contestarItem = null

  }

  render() {
    let title = "Detalhes";

    if (this.obs.item) {
      title = `Detalhes: item ${this.obs.item.numero}`;
    }

    return (
      <>

        <Dialog
          isOpen={true}
          title={title}
          onClose={this.props.onClose}
          className="detail-item"
        >
          <div className={Classes.DIALOG_BODY}>
            {(this.obs.item && this.renderData()) || this.renderNoData()}
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" onClick={this.props.onClose} />
            </div>
          </div>
        </Dialog>

        {this.obs.openContestar && (
          <ContestarSugerido
            tipo={ResultadoStore.obs.tipo}
            modelo={ResultadoStore.obs.modelo}
            item={this.obs.contestarItem}
            sugerido_list={this.obs.item.sugerido_list}
            onClose={this.handleCloseContestar.bind(this)}
            onCancel={this.handleCancelContestar.bind(this)}
          />
        )}

      </>

    );
  }
}
